export interface SldpSettings {
  latencyTolerance?: number;
  latencyAdjustMethod?: 'seek' | 'fast-forward';
  buffering?: number;
}

// SLDP Player Settings: https://softvelum.com/player/web/
export const DEFAULT_SLDP_SETTINGS: Required<SldpSettings> = {
  latencyTolerance: 100,
  latencyAdjustMethod: 'seek',
  buffering: 100,
};
